import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { of } from 'rxjs';

export function provideMatIconRegistryTesting(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: MatIconRegistry,
      useValue: {
        addSvgIcon: () => undefined,
        addSvgIconSet: () => undefined,
        addSvgIconSetLiteral: () => undefined,
        classNameForFontAlias: () => '/test.svg',
        getNamedSvgIcon: () => of(document.createElementNS('http://www.w3.org/2000/svg', 'svg')),
        getDefaultFontSetClass: () => ['test'],
      },
    },
  ]);
}
